<template>
    <Teleport to="body">
        <div class="modal fade" ref="form" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered adjust-margin">
                <div class="modal-content background:linear-gradient(0deg,#FFFFFF,#FFFFFF),linear-gradient(0deg,#CECECE,#CECECE);">
                    <div class="modal-header flex jc:end!">
                        <button class="close w:25 h:25" data-bs-dismiss="modal" type="button">
                            <span class="fa-solid fa-xmark"></span>
                        </button>
                    </div>
                    <div class="modal-body p:0|64!@sm p:0|16! flex flex-direction:column jc:center ai:center mb:24">
                        <span class="font-weight:500 f:24 lh:38.4px d:inline-block mb:40">問題回報</span>
                        <form class="w:full" @submit.prevent="submit">
                            <div class="mb:24">
                                <label class="form-label">選擇問題項目</label>
                                <select class="form-select {font-weight:400;f:16px;lh:22.4px;ls:1;color:gray01}" required v-model="category_id">
                                    <option :key="item.id" v-for="(item) in options" :value="item.id">{{ item.title }}</option>
                                </select>
                            </div>
                            <div class="mb:24">
                                <label class="form-label">詳細說明</label>
                                <textarea class="form-control {font-weight:400;f:16px;lh:22.4px;ls:1;color:gray01;b:1|solid|gray04}" placeholder="請描述您遇見的問題" required rows="5" v-model.trim="content"></textarea>
                                <div class="flex jc:end">
                                    <form-control-counter max="100" :value="content.length"></form-control-counter>
                                </div>
                            </div>
                            <div class="flex jc:center">
                                <button class="btn btn-primary" type="submit">送出</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div ref="modal" tabindex="-1" class="
            modal fade
            {max-w:1280}_.modal-dialog@xl
            {max-w:700}_.modal-dialog@sm
            {max-w:400}_.modal-dialog@<sm
            {box-shadow:0|0|20|0|black/.1}_.modal-content
            {r:12;b:1|solid|#FFE58F;p:24;background:#FFFCEF}_.modal-body
        ">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-body">
                        <div class="font-weight:400 f:18 lh:28.8px color:rgba(0,0,0,0.85) flex flex:nowrap lines:1">
                            <i class="fa-regular fa-circle-check mr:10 color:#fea84c f:28 text:center"></i>
                            <span>謝謝您的回報，您的回報已送出！</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script setup>
    const props = defineProps({
        options: { required: true, type: Array },
        post_id: { required: true, type: Number }
    });

    const category_id = ref(props.options[0]?.id);
    const content = ref("");
    const form = ref();
    const modal = ref();

    const show = () => {
        category_id.value = props.options[0]?.id;
        content.value = "";

        $(form.value).modal("show");
    };

    const submit = () => {
        api("api/inform/create", {
            category_id: category_id.value,
            post_id: props.post_id,
            content: content.value
        }).done((res) => {
            if (res.success) {
                $(form.value).modal("hide");
                $(modal.value).modal("show");

                setTimeout(() => $(modal.value).modal('hide'), 3000);
            }
        });
    };

    defineExpose({ show });

    onMounted(() => {
        $(form.value).on("show.bs.modal", () => $("#viewModal").addClass("z:1049!"));
        $(form.value).on("hidden.bs.modal", () => $("#viewModal").removeClass("z:1049!"));
    });
</script>
